import { simplApi } from '../../api/simplApi';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_SETTINGS = 'REQUEST_SETTINGS';
export const RECEIVE_SETTINGS = 'RECEIVE_SETTINGS';

// ------------------------------------
// Actions
// ------------------------------------
export function requestSettings() {
  return {
    type: REQUEST_SETTINGS,
  };
}

export function receiveSettings(settings) {
  return {
    type: RECEIVE_SETTINGS,
    payload: {
      settings,
    },
  };
}

export const fetchSettings = () => dispatch => {
  dispatch(requestSettings());

  const url = 'settings';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(receiveSettings(json));
      }
    });
};

export const saveSettings = settings => dispatch => {
  dispatch(requestSettings());

  const url = 'settings/';
  const options = { method: 'post', body: { settings } };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', 'Einstellungen gespeichert'));
      }
    });
};

export const actions = {
  requestSettings,
  receiveSettings,
  fetchSettings,
  saveSettings,
};

const SETTINGS_ACTION_HANDLERS = {
  [REQUEST_SETTINGS]: state => ({
    ...state,
    fetching: true,
  }),
  [RECEIVE_SETTINGS]: (state, action) => ({
    ...state,
    settings: action.payload.settings,
    fetching: false,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  settings: {},
};

export default function settingsReducer(state = initialState, action) {
  const handler = SETTINGS_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js